<template>
<div class="vipPrivilege-wrap"> 
  <div class="vipPrivilege">
    <div data-v-6e3c2862="" class="privileges">
      <div data-v-6e3c2862="" class="group-t"><span data-v-6e3c2862="" class="line-left"></span>VIP尊享特权<span data-v-6e3c2862="" class="line-right"></span></div>

    </div>
    <div v-if="vipLis.length > 0">
      <div data-v-3190160e="" class="_3di95a3H" v-for="(item, index) in vipLis" :key="index"  v-if="item.status == 1">
        <div data-v-3190160e="" class="_1HjYPvvp">
          <p data-v-3190160e="">VIP{{ index + 1 }}达成及返水比例</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">累计流水</p>
          <p data-v-3190160e="">{{ item.flow }}</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">累计充值</p>
          <p data-v-3190160e="">{{ item.recharge }}</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">真人返水</p>
          <p data-v-3190160e="">{{ item.realperson }}%</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">电子返水</p>
          <p data-v-3190160e="">{{ item.electron }}%</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">棋牌返水</p>
          <p data-v-3190160e="">{{ item.joker }}%</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">体育返水</p>
          <p data-v-3190160e="">{{ item.sport }}%</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">彩票返水</p>
          <p data-v-3190160e="">{{ item.lottery }}%</p>
        </div>
        <div data-v-3190160e="" class="_1HjYPvvp returnBack">
          <p data-v-3190160e="">电竞返水</p>
          <p data-v-3190160e="">{{ item.e_sport }}%</p>
        </div>
      </div>
    </div>
  </div>
  <div style="height:60px"></div>
</div>
</template>
<script>
export default {
  name: 'vip',
  data() {
    return { vipLis: [] };
  },
  created() {
    let that = this;
    that.uservip();
  },
  methods: {
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
._3di95a3H {
  width: 90%;
  height: auto;
  margin: 15px auto;
}
._3di95a3H ._1HjYPvvp:first-of-type {
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

._3di95a3H ._1HjYPvvp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: #fff;
  border: 1px solid #e9edf6;
  border-bottom: none;
  line-height: 1.5;
  overflow: hidden;
}
._3di95a3H ._1HjYPvvp p {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #3f5075;
  font-size: 14px;
  min-height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 5px;
}
._3di95a3H ._1HjYPvvp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: #fff;
  border: 1px solid #e9edf6;
  border-bottom: none;
  line-height: 1.5;
  overflow: hidden;
}
._3di95a3H ._1HjYPvvp p:nth-child(n + 2) {
  border-left: 1px solid #e9edf6;
}

._3di95a3H .returnBack p {
  min-height: 41.6px;
}
._3di95a3H ._1HjYPvvp p {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #3f5075;
  font-size: 14px;
  min-height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 5px;
}
.vipPrivilege-wrap .vipPrivilege  .privileges {
    padding: 10px 0;
    background: #151519;
    border-radius: 15px 15px 0 0;
}
  .group-t {
    text-align: center;
    font-size: 16px;
    color: #e0e0e0;
    margin-bottom: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.vipPrivilege-wrap .vipPrivilege  .group-t .line-left {
    width: 51px;
    height: 1px;
    background-color: hsla(0,0%,100%,.1);
    display: inline-block;
    margin-right: 18px;
}
.vipPrivilege-wrap .vipPrivilege  .group-t .line-right {
    width: 51px;
    height: 1px;
    background-color: hsla(0,0%,100%,.1);
    display: inline-block;
    margin-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/vip.vue